<ta-icon [status]="status" icon="spinner" spin></ta-icon>
